export default "__VITE_ASSET__CMFh7mO2__"